export function gtm() {
    $('.slick-slider.slick-slider__homepage-banner').on('afterChange', function (slick, currentSlide) {
        dataLayer.push({
            event: 'home-page-slide-changed',
        });
    });
}
